import React, { useEffect, useState } from 'react';
import uniqueId from '../utilities/unique-id';

const RadioGroup = ({
    i18n,
    required = false,
    text,
    defaultValue,
    name,
    options = [],
    onChange,
}) => {
    const label = text || i18n[name]
    const [value, setValue] = useState(defaultValue)

    if (!options.length) {
        return null;
    }

    useEffect(() => {
        if (onChange) {
            onChange(value)
        }
    }, [value])

    return <div>
        <fieldset className="relative">
            <legend className={'text-sm mb-0.5'}>
                { label } { required ? <span style={{ color: '#C90600' }}>*</span> : null }
            </legend>

            <div className={'flex flex-wrap'}>
                { options.map(option => {
                    const radioId = uniqueId();

                    return <div key={ radioId} className="mt-2.5 flex pr-10 w-full md:w-1/2">
                        <input onChange={() => setValue(option.value) } id={ radioId } name={`${name}[]`} type="radio" value={ option.value } checked={ option.value === defaultValue } className="styled-input form-dot" />
                        <label htmlFor={ radioId } className="pl-2.5 flex-1 text-grey-500">
                            { option.label }
                        </label>
                    </div>
                })}
            </div>

            { required && options.length && <input type="hidden" name={ `${name}_required` } value={'1'} /> }
        </fieldset>
    </div>
}

export default RadioGroup
